import React from 'react'

const Mirror: React.FC = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/mirror.svg" alt="mirror"/>
  )
}

export default Mirror;